/** @format */

// Query keys
export const QUERY_KEYS = {
  USER_PROFILE: "userProfile",
  SHIPMENTS: "shipments",
  PORTS: "ports",
  DASHBOARD_SUMMARY: "dashboard-summary",
  NOTIFICATIONS: "notifications",
  DOCUMENTS: "documents",
  AWAITING_DOCUMENTS: "awaiting-documents",
};
